/* eslint-disable @typescript-eslint/no-explicit-any */
import { Instant } from 'js-joda';
import _ from 'lodash';
import fetch from 'cross-fetch';

import AppConstants from 'constants/AppConstants';
import AppSettings from 'settings/AppSettings';
import protos from 'utils/protos';

const { BusinessOnboardingSignup, BusinessOnboardingState } = protos;

export function authenticateWithToken(token: any): ApiAction {
  return {
    TockApi: {
      getProto: `/onboarding/token/auth?token=${token}`,
      type: AppConstants.ONBOARDING_GET_AUTH,
    },
  };
}

export function completeStep(step: any): ApiAction {
  const request = BusinessOnboardingState.create();
  request.state = step;

  return {
    TockApi: {
      putProto: '/onboarding',
      request,
      type: AppConstants.ONBOARDING_UPDATE_COMPLETED_STEP,
    },
  };
}

export function createBusiness(onboardingData: any): ApiAction {
  const request = BusinessOnboardingSignup.fromObject(
    _.omitBy(onboardingData as any[], (value) => _.isNull(value))
  );
  return {
    TockApi: {
      postProto: '/onboarding/signup',
      request,
      type: AppConstants.ONBOARDING_CREATE_BUSINESS,
    },
  };
}

export function fetchTimeZone(lat: any, lng: any) {
  return (dispatch: Dispatch) => {
    const apiKey = AppSettings.GOOGLE_API_KEY;
    const timestamp = Instant.now().toEpochMilli() / 1000;
    const requestUrl =
      'https://maps.googleapis.com/maps/api/timezone/json' +
      `?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`;
    return fetch(requestUrl)
      .then((resp: any) => resp.json())
      .then((resp: any) => {
        if (resp.timeZoneId) {
          dispatch({
            type: AppConstants.ONBOARDING_FETCH_TIME_ZONE_DONE,
            payload: resp,
          });
        }
      });
  };
}

export function fetchNewAuthenticationRoles(): ApiAction {
  return {
    TockApi: {
      getProto: '/authenticate/roles',
      type: AppConstants.ONBOARDING_FETCH_NEW_ROLES,
    },
  };
}

export function fetchOnboardingDataByToken(token: any): ApiAction {
  return {
    TockApi: {
      getProto: `/onboarding?token=${token}`,
      type: AppConstants.ONBOARDING_GET_BUSINESS,
      onError: _.noop,
    },
  };
}

export function fetchOnboardingCompletedSteps(): ApiAction {
  return {
    TockApi: {
      getProto: '/onboarding',
      type: AppConstants.ONBOARDING_STEPS_FETCH,
      onError: _.noop,
    },
  };
}

export function notifySalesOnboardingComplete() {
  return {
    TockApi: {
      postProto: '/onboarding/sales/notifyOnboardComplete',
      type: AppConstants.ONBOARDING_NOTIFY_SALES_SETUP_COMPLETE,
      onError: _.noop,
    },
  };
}

export function isDomainAvailable(domainName: any): ApiAction {
  return {
    TockApi: {
      getProto: `/business/domain?domain=${encodeURIComponent(domainName)}`,
      type: AppConstants.ONBOARDING_DOMAIN_CHECK,
    },
  };
}

export function saveTermsOfService(tosContents: string, newBusinessId?: number): ApiAction {
  return {
    TockApi: {
      postFile: `/business/upload/tos?newBusinessId=${newBusinessId ?? 0}`,
      request: tosContents,
      type: AppConstants.ONBOARDING_SAVE_TOS,
    },
  };
}

export function saveTermsOfServiceAddon(addonContents: string): ApiAction {
  return {
    TockApi: {
      postFile: '/business/upload/tos?documentType=SERVICE_AGREEMENT_SMS_ADDENDUM',
      request: addonContents,
      type: AppConstants.ONBOARDING_SAVE_TOS_ADDON,
    },
  };
}

export function saveWineShopTermsOfServiceAddon(addonContents: string): ApiAction {
  return {
    TockApi: {
      postFile: '/business/upload/tos?documentType=WINE_SHOP_ADDENDUM',
      request: addonContents,
      type: AppConstants.ONBOARDING_SAVE_WINE_SHOP_TOS_ADDON,
    },
  };
}

export function updateState(state: any): BaseTockAction {
  return {
    type: AppConstants.ONBOARDING_UPDATE_STORE_STATE,
    payload: state,
  };
}

export function setShouldRefreshOnboardingSteps(state: boolean): Promise<unknown> {
  return Promise.resolve({
    type: AppConstants.ONBOARDING_STORE_SET_REFRESH_ONBOARDING,
    payload: state,
  });
}

export function updateLocalesAvailable(country: any): BaseTockAction {
  return {
    type: AppConstants.BUSINESS_LOCALES_AVAILABLE_UPDATE,
    payload: country,
  };
}

export function getUpdatedTermsOfServiceInfo(token: string): ApiAction {
  return {
    TockApi: {
      getProto: `/business/updated/tos?token=${token}`,
      type: AppConstants.UPDATED_TERMS_OF_SERVICE_FETCH,
    },
  };
}
